import { typeofArray, typeofObject } from "./"

export function GoogleTagManager(dataLayer) {
  window.dataLayer = [] = dataLayer;
  console.log(window.dataLayer);
  (function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
    var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', 'GTM-N57TLT');
}

export function pushGoogleTagManager(parameter) {
  if (window.dataLayer) {
    window.dataLayer.push(parameter);
  }
}

export function pushUserInformationGoogleTagManager(userInformation = null, dataLayer = null) {
  if (dataLayer && typeofArray(dataLayer) && userInformation && typeofObject(userInformation)) {
    dataLayer.push(userInformation)
  }
}

export function getKeyWordByUrl(key1, key2) {
  if (window && window.location && window.location.href) {
    let url = window.location.href,
      key = null;
    if (key1 && url.indexOf(key1) > 0) {
      key = key1;
    } else if (key2 && url.indexOf(key2) > 0) {
      key = key2;
    } else {
      return '';
    }
    return decodeURIComponent(url.slice(url.indexOf(key)).replace(key, ''));
  }
  return null;
}




// WEBPACK FOOTER //
// ./common/Utils/googleTagManagerUtil.js